export const SET_EDIT_ROLE_PAGINATED_REPORTS_LOADED = "SET_EDIT_ROLE_PAGINATED_REPORTS_LOADED";

export const setEditRolePaginatedReportsLoaded = (editRolePaginatedReportsLoaded: boolean) => {
  return {
    editRolePaginatedReportsLoaded,
    type: SET_EDIT_ROLE_PAGINATED_REPORTS_LOADED
  };
};
